module.exports = __webpack_public_path__ + "static/img/price.a6d743b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/price.png
// module id = emvA
// module chunks = 0